

export const FETCH_VEHICLE_STEREOTYPE_LIST = {
    START: 'FETCH_VEHICLE_STEREOTYPE_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_STEREOTYPE_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_STEREOTYPE_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_STEREOTYPE_INIT="FETCH_VEHICLE_STEREOTYPE_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_STEREOTYPE_SCREEN =
'INIT_CREATE_VEHICLE_STEREOTYPE_SCREEN';

export const CREATE_VEHICLE_STEREOTYPE = {
START: 'CREATE_VEHICLE_STEREOTYPE_START',
SUCCESS: 'CREATE_VEHICLE_STEREOTYPE_SUCCESS',
ERROR: 'CREATE_VEHICLE_STEREOTYPE_ERROR',
};

export const EDIT_VEHICLE_STEREOTYPE = {
START: 'EDIT_VEHICLE_STEREOTYPE_START',
SUCCESS: 'EDIT_VEHICLE_STEREOTYPE_SUCCESS',
ERROR: 'EDIT_VEHICLE_STEREOTYPE_ERROR',
};

export const FETCH_VEHICLE_STEREOTYPE_DETAIL = {
  START: 'FETCH_VEHICLE_STEREOTYPE_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_STEREOTYPE_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_STEREOTYPE_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_STEREOTYPE = {
  START: 'EXPORT_VEHICLE_STEREOTYPE_START',
  SUCCESS: 'EXPORT_VEHICLE_STEREOTYPE_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_STEREOTYPE_ERROR',
};
export const VEHICLE_MODELDD = {
  START: 'VEHICLE_MODELDD_START',
  SUCCESS: 'VEHICLE_MODELDD_SUCCESS',
  ERROR: 'VEHICLE_MODELDD_ERROR',
};

export const VEHICLE_STEREOTYPE_DD = {
  START: 'VEHICLE_STEREOTYPE_DD_START',
  SUCCESS: 'VEHICLE_STEREOTYPE_DD_SUCCESS',
  ERROR: 'VEHICLE_STEREOTYPE_DD_ERROR',
};

export const DELETE_VEHICLE_STEREOTYPE = {
  START: 'DELETE_VEHICLE_STEREOTYPE_START',
  SUCCESS: 'DELETE_VEHICLE_STEREOTYPE_SUCCESS',
  ERROR: 'DELETE_VEHICLE_STEREOTYPE_ERROR',
};

export const VEHICLE_STEREOTYPE_SAVE_TABLE_STATE = 'VEHICLE_STEREOTYPE_SAVE_TABLE_STATE';